import React from 'react'
import { useTranslation } from 'next-i18next'

import CustomRadioButton from '../custom-radio-button'

const PropertyType = () => {
  const { t } = useTranslation()

  const options = [
    {
      key: t('common.apartment', 'Apartment'),
      value: 'condo'
    },
    {
      key: t('common.house', 'House'),
      value: 'house'
    },
    {
      key: t('common.townhouse', 'Townhouse'),
      value: 'townhouse'
    }
  ]

  return <CustomRadioButton options={options} name="type" control="radio" />
}

export default PropertyType
